import React from 'react';
import { LevelProps } from '../types';
import { Match } from '../../Results/Match';

export const ResultTreeFixture: React.FC<LevelProps> = ({id, tree}) => {
    const fixture = tree.fixtures[id];

    return (
        <Match fixture={{ ...fixture, ms: tree.ms[id] || undefined, ss: tree.ss[id] || undefined }} />
    )
}